import * as c from "../utils/constants/constants";
/*==========logs out the user based on type of login. if login type is SSO, its re-directed to ssoRedirect page, else redirectd to root page*/
export const forceLogout = () => {
  console.log('force logout');
  localStorage.clear();
  sessionStorage.clear();
      if(c.SSO === 'true')
        window.location.pathname = '/ssoRedirect';
      else
        window.location.pathname = '/';
      return;
}